import { defineMessages } from 'react-intl';

const autoLinkConsentMessages = defineMessages({
  pageTitle: {
    id: 'autoLinkConsent.pageTitle',
    defaultMessage: 'Your accounts have been merged',
    description: 'The page title for auto link consent.',
  },

  // Use case 1: Learners with existing APN accounts, no BID account
  learningHistoryMergedDescription: {
    id: 'autoLinkConsent.learningHistoryMergedDescription',
    defaultMessage:
      'You already have an AWS Training & Certification account with <b>{email}</b>. It was last accessed on {date} using {oldProviderName}. We have merged this account with your {newProviderName} account. Your learning progress and achievements are now available through your {newProviderName} account.',
    description: 'Description for APN to BID account linking scenario.',
  },

  // Use case 2: Learners with existing APN accounts and a BID account
  accountsMergedDescription: {
    id: 'autoLinkConsent.accountsMergedDescription',
    defaultMessage:
      'You already have an AWS Training & Certification account with <b>{email}</b>. It was last accessed on {date} using {oldProviderName}. We have merged this account with your {newProviderName} account. Please allow up to one business day for your learning progress and achievements to appear in your {newProviderName} account.',
    description: 'Description for APN and BID account merging scenario.',
  },
  button: {
    id: 'autoLinkConsent.button',
    defaultMessage: 'Continue',
    description: 'The button text for auto link consent.',
  },
});

export default autoLinkConsentMessages;
